import { dumbledoreMediaArray } from './dumbledoreMedia'
import { dumbledoreBio } from './dumbledoreBios'
import { hermioneProfileReviewHinge, ronProfileReviewBumble, harryProfileReviewTinder } from './dumbledoreProfileReviews'

export const dumbledoreDatingProfileHinge = {
  _id: 'dumbledoreDatingProfileHingeId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...hermioneProfileReviewHinge }
  ],
  mediaItems: [ ...dumbledoreMediaArray ],
  bioItems: { ...dumbledoreBio },
}

export const dumbledoreDatingProfileBumble = {
  _id: 'dumbledoreDatingProfileBumbleId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: dumbledoreBio.aboutMe[0],
    hobbies: [dumbledoreBio.hobbies[0], dumbledoreBio.hobbies[1], dumbledoreBio.hobbies[2], dumbledoreBio.hobbies[3], dumbledoreBio.hobbies[4] ],
  },
  profileReviews: [
    { ...ronProfileReviewBumble }
  ],
  mediaItems: [ ...dumbledoreMediaArray ],
  bioItems: { ...dumbledoreBio },
}

export const dumbledoreDatingProfileTinder = {
  _id: 'dumbledoreDatingProfileTinderId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: dumbledoreMediaArray[0]._id,
      mediaItemURL: dumbledoreMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[0].type,
      caption: dumbledoreMediaArray[0].captions[0],
      subcaption: dumbledoreMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[4]._id,
      mediaItemURL: dumbledoreMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[4].type,
      caption: dumbledoreMediaArray[4].captions[2],
      subcaption: dumbledoreMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[7]._id,
      mediaItemURL: dumbledoreMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[7].type,
      caption: dumbledoreMediaArray[7].captions[1],
      subcaption: dumbledoreMediaArray[7].subcaptions[1],
    },
    {
      mediaItemId: dumbledoreMediaArray[8]._id,
      mediaItemURL: dumbledoreMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[8].type,
      caption: dumbledoreMediaArray[8].captions[0],
      subcaption: dumbledoreMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[1]._id,
      mediaItemURL: dumbledoreMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[1].type,
      caption: dumbledoreMediaArray[1].captions[0],
      subcaption: dumbledoreMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: dumbledoreMediaArray[6]._id,
      mediaItemURL: dumbledoreMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: dumbledoreMediaArray[6].type,
      caption: dumbledoreMediaArray[6].captions[2],
      subcaption: dumbledoreMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: dumbledoreBio._id,
    vitalInfo: { ...dumbledoreBio.vitalInfo },
    prompts: [
      { ...dumbledoreBio.prompts[0] },
      { ...dumbledoreBio.prompts[1] },
      { ...dumbledoreBio.prompts[2] }
    ],
    aboutMe: dumbledoreBio.aboutMe[0],
    hobbies: [dumbledoreBio.hobbies[0], dumbledoreBio.hobbies[1], dumbledoreBio.hobbies[2], dumbledoreBio.hobbies[3], dumbledoreBio.hobbies[4] ],
  },
  profileReviews: [
    { ...harryProfileReviewTinder }
  ],
  mediaItems: [ ...dumbledoreMediaArray ],
  bioItems: { ...dumbledoreBio },
}